import { render, staticRenderFns } from "./amap.vue?vue&type=template&id=4a6fb252&scoped=true"
import script from "./amap.vue?vue&type=script&lang=js"
export * from "./amap.vue?vue&type=script&lang=js"
import style0 from "./amap.vue?vue&type=style&index=0&id=4a6fb252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fb252",
  null
  
)

export default component.exports